import { createUserFullName } from '@/helpers/createUserFullName';
import { useGetCurrentUserQuery } from '@/services/users';
import {
  Box,
  Button,
  Card,
  RadioGroup,
  useBreakpoint,
  useTheme,
  Spinner,
  Theme,
} from '@palmetto/palmetto-components';
import { Helmet } from 'react-helmet';
import { useNavigate, Route, Routes } from 'react-router-dom';

import { MainContainer } from '../MainContainer';
import { PropertyValue } from '../PropertyValue';

import { EditProfile } from './EditProfile';

export function YourProfile() {
  const { isPhone } = useBreakpoint();
  const navigate = useNavigate();
  const { data: user, isLoading } = useGetCurrentUserQuery();

  const { theme, setTheme } = useTheme();
  const options = [
    {
      id: 'light',
      value: 'light',
      label: 'Light',
    },
    {
      id: 'dark',
      value: 'dark',
      label: 'Dark',
    },
    {
      id: 'system',
      value: 'system',
      label: 'System',
    },
  ];

  return (
    <>
      <Helmet>
        <title>Your Palmetto Finance Profile</title>
      </Helmet>
      <MainContainer>
        <Box gap="2xs" padding={{ base: '0 lg', tablet: '0' }}>
          <Box as="h1" fontSize={{ base: 'lg', tablet: 'xl', desktop: '2xl' }} fontWeight="medium">
            Your Profile
          </Box>
          <Box
            overflow="hidden"
            display="block"
            style={{ textOverflow: 'ellipsis', minWidth: '0', whiteSpace: 'nowrap' }}
          >
            {isLoading ? '' : createUserFullName(user?.givenName, user?.familyName)}
          </Box>
        </Box>
        <Card>
          <Box padding="lg" gap="sm">
            {isLoading ? (
              <Spinner size="lg" />
            ) : (
              <>
                {user && (
                  <Box padding="0 0 sm 0" alignItems="flex-end">
                    <Button
                      as="a"
                      navigate={() => navigate(`/profile/edit`)}
                      variant="primary"
                      tone="neutral"
                      size="sm"
                      aria-label="Edit Profile"
                      iconPrefix="pencil"
                    >
                      {!isPhone && 'Edit'}
                    </Button>
                  </Box>
                )}
                <PropertyValue label="First Name" value={user?.givenName} />
                <PropertyValue label="Last Name" value={user?.familyName} />
                <PropertyValue label="Email" value={user?.email} />
                <PropertyValue label="Phone Number" value={user?.phoneNumber} />
                <PropertyValue label="Use as Sales Rep" value={user?.userIsSalesRep ? 'Yes' : 'No'} />
              </>
            )}
          </Box>
        </Card>

        <Card>
          <Card.Section>
            <RadioGroup
              title="Appearance"
              name="SelectTheme"
              value={theme}
              options={options}
              onChange={(event) => setTheme(event.target.value as Theme)}
            />
          </Card.Section>
        </Card>
      </MainContainer>
      <Routes>
        <Route path="edit" element={<EditProfile />} />
      </Routes>
    </>
  );
}
